import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { Document } from "@/types/models";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { DeleteStage } from "@/hooks/useDeleteEvidenceDocument";

interface DeleteDocumentDialogProps {
  deletingDoc: Document | null;
  deleteStage: DeleteStage;
  errorMessage: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteDocumentDialog = ({
  deletingDoc,
  deleteStage,
  errorMessage,
  onCancel,
  onConfirm,
}: DeleteDocumentDialogProps) => (
  <Dialog open={!!deletingDoc} onOpenChange={(open) => { if (!open) onCancel(); }}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-destructive">
          <AlertTriangle className="w-5 h-5" /> Delete Document
        </DialogTitle>
        <DialogDescription>
          This will permanently delete the file, its metadata, and all index entries. This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <p className="text-sm font-medium text-foreground break-words">{deletingDoc?.title || deletingDoc?.filename}</p>
      {errorMessage && (
        <p className="text-sm text-destructive">{errorMessage}</p>
      )}
      <div className="flex justify-end gap-3 mt-2">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={deleteStage !== "idle"}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          disabled={deleteStage !== "idle"}
          className="gap-1.5"
        >
          {deleteStage !== "idle" ? (
            <><Loader2 className="w-4 h-4 animate-spin" /> Deleting...</>
          ) : (
            <><Trash2 className="w-4 h-4" /> Delete</>
          )}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default DeleteDocumentDialog;
